// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dashboard-content-panel_wrapper__-1nGW"};